//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.ul`
    width: 100%;
    background-color: var(--light-1);
    box-shadow: 0px 5px 8px #4A4A4A33;
    list-style: none;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 0;
    margin: 0;
    max-height: 28vh;
    position: ${({ position = "relative" }) => position};
    top: 105%;
    z-index: 30;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background-color: var(--light-gray-4);
    }
    & li {
        margin: 0;
        font-size: 14px;
        padding: 12px 16px;
        text-align: ${({ align = "center" }) => align};
        transition: 0.35s;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
    }
    & li:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
    }
    & li:hover {
        background-color: var(--light-blue-3);
    }
`;